import classNames from "classnames";
import styles from "./styles.module.scss";

interface DataCardProps {
  title: string;
  value: string;
  className?: string;
}

const DataCard = ({ title, value, className }: DataCardProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{value}</p>
    </div>
  );
};

export default DataCard;
